// storeAsUTC — pure normalization of a time string to a UTC ISO string.
//
// Extracted verbatim from `FlightLookup.js` (module-level `storeAsUTC` helper) as
// part of the behavior-preserving refactor (issue #240). FlightAware returns UTC
// times with a `Z` suffix, so no correction is applied beyond round-tripping
// through `Date` to a canonical ISO string.
//
// Totality preserved exactly: returns `null` for a falsy input, matching the
// source. The source did not guard an unparseable non-empty string (it would
// produce an Invalid Date and `toISOString()` would throw), so no extra guard is
// added — behavior is identical.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Normalizes a time string to a UTC ISO string.
 *
 * @param {string|null|undefined} timeString - The time string to normalize.
 * @returns {string|null} The UTC ISO string, or `null` when input is falsy.
 */
export function storeAsUTC(timeString) {
  if (!timeString) {
    return null;
  }
  return new Date(timeString).toISOString();
}

export default storeAsUTC;
